
import React, { useCallback, useMemo, useState, useEffect } from 'react'
import { connect } from "react-redux"
import { Layout } from 'antd';
import './layout.scss'
import { Footer, Header, Menu } from "../Widgets"
import { useSelector } from 'react-redux'
import NotPermission from 'components/NotPermission/NotPermission';
import { ModalDirectLinkContextProvider } from 'components/ModalDirectLink';
import useAddPermissionToUrl from 'hooks/AddPermissionToUrl';
import { ALL_PERMISSION, hasPermission, NOT_AUTHENTICATION_PERMISSION } from 'constants/permission';
import UnLock from 'components/UnLock/UnLock';
import HomeMenu from 'Page/HomeMenu';

const WrapComponent = (props) => {
  const { Component, permissions } = props;
  useAddPermissionToUrl(permissions);
  const setting = useSelector(state => state.setting);
  if (
    props.permission !== NOT_AUTHENTICATION_PERMISSION &&
    !hasPermission(props.permission)
  ) {
    return <NotPermission />;
  }
  const isNotShow = ALL_PERMISSION?.[props?.permission]?.keyEnable 
    ? (setting?.[ALL_PERMISSION?.[props?.permission]?.keyEnable] === 1 ? false : true)
    : false
  return isNotShow? <UnLock /> : <Component {...props} setting={setting} />
}

function LayoutPage(props) {
  const [hasPermission, setHasPermission] = useState(true);
  const menuData = useSelector((state) => state?.common?.menu)
  const {
    isShowHeader,
    isShowFooter,
    isShowMenu,
    isHeaderTextOnly,
    isAuth,
    member = {},
  } = props
  const HeaderComponent = useCallback(() => {
    return (
      isShowHeader ? (
        <Header userData={member} isHeaderTextOnly={isHeaderTextOnly} isAuth={isAuth} />
      ) : (
        <></>
      )
    )
  }, [member, isHeaderTextOnly, isAuth]);

  const MenuComponent = useMemo(() => {
    return (
      isShowMenu ? (
        <Menu isAuth={isAuth} pathName={props.location.pathname} />
      ) : (
        <></>
      )
    )
  }, [])
  
  useEffect(() => {
    if (member.token) {
      setHasPermission(!!member.permissions)
    }
  }, [member]);

  if (!hasPermission) {
    return <NotPermission />
  }

  return (
    <ModalDirectLinkContextProvider>
      <Layout>
        {HeaderComponent()}
        {
          menuData?.isShow && member.token && (
            <HomeMenu />
          )
        }   
        <div className={!member.token ? "" : menuData?.isShow ? "d-none" : ""}>
          {MenuComponent}
          <div className="content">
            <div>
              <WrapComponent {...props} />
            </div>
          </div>
        </div>
        {
          isShowFooter ? (
            <Footer />
          ) : (
            <></>
          )
        }
      </Layout>
    </ModalDirectLinkContextProvider>
  );

}

const mapStateToProps = state => ({
  member: state.member || {},
  introduction: state.introduction || {}
});

const mapDispatchToProps = dispatch => {
  return {

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LayoutPage)
